import { useState } from 'react'
import LLMCard from './LLMCard'

function computeMedian(arr) {
  const s = [...arr].sort((a, b) => a - b)
  const m = Math.floor(s.length / 2)
  return s.length % 2 === 0 ? (s[m - 1] + s[m]) / 2 : s[m]
}

function computeStddev(arr) {
  if (arr.length < 2) return 0
  const mean = arr.reduce((a, b) => a + b, 0) / arr.length
  return Math.sqrt(arr.reduce((sum, v) => sum + (v - mean) ** 2, 0) / arr.length)
}

export default function CategoryTabs({ report }) {
  const categories = Object.keys(report?.llm_results?.[0]?.categories || {})
  const [activeCategory, setActiveCategory] = useState(categories[0] ?? null)

  // If the stored category no longer exists in this report (e.g. user switched audits),
  // fall back to the first available category without waiting for a re-render.
  const effectiveCategory = categories.includes(activeCategory) ? activeCategory : (categories[0] ?? null)

  if (!report?.llm_results?.length) {
    return (
      <div className="text-center py-12 text-[#77726e]">
        Aucun modèle LLM disponible
      </div>
    )
  }

  if (!categories.length) {
    return (
      <div className="text-center py-12 text-[#77726e]">
        Aucune catégorie disponible
      </div>
    )
  }

  const allScores = report.llm_results.flatMap(llm =>
    Object.values(llm.categories || {})
      .map(cat => cat.score)
      .filter(s => s !== null && s !== undefined)
  )
  const globalMedian = allScores.length > 0 ? computeMedian(allScores) : 50
  const globalStddev = allScores.length > 1 ? computeStddev(allScores) : 0

  return (
    <div className="w-full">
      {/* Tabs */}
      <div className="flex flex-wrap gap-2 mb-6 justify-center">
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => setActiveCategory(category)}
            className={`px-4 py-1.5 border text-xs font-semibold transition ${
              effectiveCategory === category
                ? 'bg-[#2f3126] text-[#f6f3ee] border-[#2f3126]'
                : 'bg-[#f6f3ee] text-[#2f3126] border-[#77726e]/40 hover:bg-[#d1d6d8]'
            }`}
          >
            {category.charAt(0).toUpperCase() + category.slice(1)}
          </button>
        ))}
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {report.llm_results.map((llm) => (
          <LLMCard
            key={llm.llm_name}
            llm={llm}
            category={effectiveCategory}
            categoryMedian={globalMedian}
            categoryStddev={globalStddev}
          />
        ))}
      </div>
    </div>
  )
}
